module.exports = __webpack_public_path__ + "h5/img/home5.6fea45f0.png";